/**
 * @generated SignedSource<<370a2c6b7bf6cc4cb6a44720f8e940ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProgramSpreadsheetQuery$variables = {
  component: string;
  date: string;
  program: string;
  shouldFetchSummary: boolean;
};
export type ProgramSpreadsheetQuery$data = {
  readonly activity: {
    readonly component: {
      readonly " $fragmentSpreads": FragmentRefs<"RefreshSlug">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"Activity_activity">;
  } | null | undefined;
  readonly program: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CheckInAnswerProgressPhotoUpload_program" | "RefreshSlug" | "WorkoutSectionElement_program">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useExerciseLibrary_rootRef">;
};
export type ProgramSpreadsheetQuery = {
  response: ProgramSpreadsheetQuery$data;
  variables: ProgramSpreadsheetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "component"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "program"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchSummary"
},
v4 = [
  {
    "kind": "Literal",
    "name": "client",
    "value": "$me"
  },
  {
    "kind": "Variable",
    "name": "component",
    "variableName": "component"
  },
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  }
],
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RefreshSlug"
},
v6 = [
  {
    "kind": "Literal",
    "name": "showArchived",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "program"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "raw",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(raw:true)"
},
v9 = {
  "kind": "Literal",
  "name": "format",
  "value": "MMM Do"
},
v10 = {
  "kind": "Literal",
  "name": "utc",
  "value": true
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "assetType",
  "value": [
    "WORKOUT_EXERCISE"
  ]
},
v19 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Literal",
    "name": "includeShared",
    "value": true
  }
],
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomAssetsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomAsset",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v22 = [
  (v18/*: any*/),
  (v19/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgramSpreadsheetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "shouldFetchSummary",
                "variableName": "shouldFetchSummary"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Activity_activity"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Component",
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useExerciseLibrary_rootRef"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckInAnswerProgressPhotoUpload_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkoutSectionElement_program"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProgramSpreadsheetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": "formattedDate",
            "args": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "date",
            "storageKey": "date(format:\"MMM Do\",utc:true)"
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": [
              (v9/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": "completedAt(format:\"MMM Do\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Enrollment",
            "kind": "LinkedField",
            "name": "enrollment",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActivityFeedback",
            "kind": "LinkedField",
            "name": "feedbacks",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoURL",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "read",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "fromNow"
                  }
                ],
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": "createdAt(format:\"fromNow\")"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coachReadAnswers",
            "storageKey": null
          },
          {
            "alias": "formattedLongDate",
            "args": [
              {
                "kind": "Literal",
                "name": "format",
                "value": "dddd, MMMM D"
              },
              (v10/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "date",
            "storageKey": "date(format:\"dddd, MMMM D\",utc:true)"
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startWorkout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endWorkout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "componentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Completion",
            "kind": "LinkedField",
            "name": "completion",
            "plural": false,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Component",
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "habitPrompt",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  }
                ],
                "type": "ComponentIcon",
                "abstractKey": "__isComponentIcon"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v17/*: any*/)
                ],
                "type": "Slug",
                "abstractKey": "__isSlug"
              }
            ],
            "storageKey": null
          },
          {
            "condition": "shouldFetchSummary",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivitySummary",
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Completion",
                    "kind": "LinkedField",
                    "name": "completion",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "schedule",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "longestStreak",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": "exercises",
        "args": (v20/*: any*/),
        "concreteType": "CustomAssetsConnection",
        "kind": "LinkedField",
        "name": "custom_assets",
        "plural": false,
        "selections": (v21/*: any*/),
        "storageKey": "custom_assets(assetType:[\"WORKOUT_EXERCISE\"],first:0,includeShared:true)"
      },
      {
        "alias": "exercises",
        "args": (v20/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ExerciseLibraryExercisesList_exercises",
        "kind": "LinkedHandle",
        "name": "custom_assets"
      },
      {
        "alias": "suggestedExercises",
        "args": (v22/*: any*/),
        "concreteType": "CustomAssetsConnection",
        "kind": "LinkedField",
        "name": "custom_assets",
        "plural": false,
        "selections": (v21/*: any*/),
        "storageKey": "custom_assets(assetType:[\"WORKOUT_EXERCISE\"],first:0)"
      },
      {
        "alias": "suggestedExercises",
        "args": (v22/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ExerciseAutocomplete_suggestedExercises",
        "kind": "LinkedHandle",
        "name": "custom_assets"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "type": "Slug",
            "abstractKey": "__isSlug"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bded8f44410d3f3b0a6d3941891f1d94",
    "id": null,
    "metadata": {},
    "name": "ProgramSpreadsheetQuery",
    "operationKind": "query",
    "text": "query ProgramSpreadsheetQuery(\n  $program: String!\n  $date: String!\n  $component: String!\n  $shouldFetchSummary: Boolean!\n) {\n  activity(client: \"$me\", date: $date, component: $component) {\n    ...Activity_activity_4Gefa0\n    component {\n      ...RefreshSlug\n      id\n    }\n    id\n  }\n  ...useExerciseLibrary_rootRef\n  program(slug: $program, showArchived: true) {\n    id\n    ...RefreshSlug\n    ...CheckInAnswerProgressPhotoUpload_program\n    ...WorkoutSectionElement_program\n  }\n}\n\nfragment ActivityCalendar_summary on ActivitySummary {\n  completion {\n    completed\n    total\n    rate\n  }\n  schedule {\n    id\n    date(raw: true)\n    completed\n  }\n  longestStreak\n}\n\nfragment ActivityFeedbackButton_activity on Activity {\n  ...ActivityFeedbackList_activity\n  feedbacks {\n    id\n  }\n}\n\nfragment ActivityFeedbackList_activity on Activity {\n  feedbacks {\n    id\n    ...ActivityFeedback_activityFeedback\n  }\n  ...FeedbackForm_activity\n  id\n  coachReadAnswers\n}\n\nfragment ActivityFeedback_activityFeedback on ActivityFeedback {\n  id\n  author {\n    id\n    displayName\n    photoURL\n  }\n  content\n  read\n  createdAt(format: \"fromNow\")\n}\n\nfragment ActivityStatus_activity on Activity {\n  date(raw: true)\n  formattedDate: date(utc: true, format: \"MMM Do\")\n  completed\n  completedAt(format: \"MMM Do\")\n  enrollment {\n    client {\n      displayName\n      id\n    }\n    id\n  }\n}\n\nfragment Activity_activity_4Gefa0 on Activity {\n  ...ActivityStatus_activity\n  ...ActivityFeedbackButton_activity\n  id\n  date(raw: true)\n  formattedDate: date(utc: true, format: \"MMM Do\")\n  formattedLongDate: date(utc: true, format: \"dddd, MMMM D\")\n  content\n  completed\n  submitted\n  startWorkout\n  endWorkout\n  componentId\n  completion {\n    rate\n  }\n  component {\n    locked\n    type\n    slug\n    title\n    habitPrompt\n    ...ComponentIcon_component\n    id\n  }\n  summary @include(if: $shouldFetchSummary) {\n    ...ActivityCalendar_summary\n  }\n}\n\nfragment CheckInAnswerProgressPhotoUpload_program on Program {\n  id\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ExerciseAutocomplete_rootRef on Root {\n  suggestedExercises: custom_assets(first: 0, assetType: [WORKOUT_EXERCISE]) {\n    edges {\n      node {\n        id\n        name\n        content\n        userId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ExerciseLibraryExercise_asset on CustomAsset {\n  id\n  name\n  content\n  userId\n}\n\nfragment ExerciseLibraryExercisesList_rootRef on Root {\n  exercises: custom_assets(first: 0, assetType: [WORKOUT_EXERCISE], includeShared: true) {\n    edges {\n      node {\n        id\n        ...ExerciseLibraryExercise_asset\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FeedbackForm_activity on Activity {\n  id\n  client {\n    displayName\n    id\n  }\n}\n\nfragment RefreshSlug on Slug {\n  __isSlug: __typename\n  slug\n  slugId\n}\n\nfragment WorkoutSectionElement_program on Program {\n  id\n}\n\nfragment useExerciseLibrary_rootRef on Root {\n  ...ExerciseLibraryExercisesList_rootRef\n  ...ExerciseAutocomplete_rootRef\n}\n"
  }
};
})();

(node as any).hash = "fdfe0712e8f0905fb06d15e9976b9ff3";

export default node;
